import React, { useContext, useState } from 'react';
import './models.css';
import { useParams, useLocation } from 'react-router-dom';
import { FirmwareContext } from "../../context/FirmwareContext";
import List from "../../components/list/List";
import Button from "../../components/button/Button";

const Models = () => {
  const { brand } = useParams();
  const location = useLocation();
  const firmwares = useContext(FirmwareContext);
  const [filter, setFilter] = useState("todas");

  const modelsList = firmwares
    .filter((fw) => fw.brand === brand)
    .filter((fw) => 
      filter === "todas" || fw.instalation.toLowerCase() === filter
    )
    .map((fw) => ({
      label: `${fw.model}\n${fw.instalation}`,
      instalation: fw.instalation,
      model: fw.model,
      to: `/brands/${brand}/${fw.model}/${fw.instalation}`,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));


  return (
    <div className="models-container">
        <Button route={`/brands`} text="Atrás" />

      <div className="models-card">
        <h1 className="models-title">Modelos de {brand}</h1>

        <div className="filter-container">
          <span>Modo de Instalación:</span>
          <div className="filter-buttons">
            <button 
              className={`filter-btn ${filter === "todas" ? "active" : ""}`} 
              onClick={() => setFilter("todas")}
            >
              Todas
            </button>
            <button 
              className={`filter-btn ${filter === "no forzada" ? "active" : ""}`} 
              onClick={() => setFilter("no forzada")}
            >
              No forzada
            </button>
            <button 
              className={`filter-btn ${filter === "forzada" ? "active" : ""}`} 
              onClick={() => setFilter("forzada")}
            >
              Forzada
            </button>
          </div>
        </div>

        {modelsList.length > 0 ? (
          <List items={modelsList} />
        ) : (
          <p className="no-models">No hay modelos disponibles para esta marca.</p>
        )}

        {location.state && (
          <div>
            <h3>Datos del firmware</h3>
            <pre>{JSON.stringify(location.state.firmwareData, null, 2)}</pre>
          </div>
        )}
      </div>

    </div>
  );
}

export default Models;